import React, { useState, useEffect } from "react";
import LandingNav from "./Landing_Nav";
import LandingFooter from "./Landing_Footer";
import { Helmet } from "react-helmet";

const Privacy = ({
  onSignUpClick,
  onLoginClick,
  country,
  handleCountryChange,
}) => {

  return (
    <>
      <Helmet>
        <title>
          Whatsappbulksend Privacy Policy - Your Data Security is Our Priority
        </title>
        <meta
          name="description"
          content="Read Whatsappbulksend's privacy policy to understand how we protect your data. Learn about our commitment to data security, user privacy, and transparent practices. Your trust is important to us."
        />
        <meta
          name="keywords"
          content="Whatsappbulksend privacy policy, data security, user privacy, Privacy policy, data protection"
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Whatsappbulksend Privacy Policy - Your Data Security is Our Priority",
              "description": "Read Whatsappbulksend's privacy policy to understand how we protect your data. Learn about our commitment to data security, user privacy, and transparent practices.",
              "url": "https://Whatsappbulksend.com/PrivacyPolicy,
              "publisher": {
                "@type": "Organization",
                "name": "Whatsappbulksend",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://bumppy.in/Whatsappbulksend/api/v1/uploads/utils/Whatsappbulksend_logo.webp"
                }
              },
              "mainEntity": {
                "@type": "WebPageElement",
                "name": "Privacy Policy"
              }
            }
          `}
        </script>
      </Helmet>
    
      <div className="w-100 landing-body-bg">
        <LandingNav
          onSignUpClick={onSignUpClick}
          onLoginClick={onLoginClick}
          country={country}
          handleCountryChange={handleCountryChange}
        />

        <div className="padding-5-rem p-5">
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="bg-white border-radius-20 px-lg-5 px-3 py-3">
                <p className="text-3-2">Table of Content</p>
                <ul>
                  <li>Information We Collect</li>
                  <li>Consent</li>
                  <li>Disclosure</li>
                  <li>Payment</li>

                  <li>ThirdParty Services</li>

                  <li>Security</li>

                  <li>Cookies</li>
                  <li> Age of Consent</li>

                  <li>Changes to This Privacy Policy</li>

                  <li>Contact Information</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-8 col-12 pt-lg-0 pt-3">
              <div className="bg-white border-radius-20 pb-5 ">
                <div className="text-2-2  py-4 px-lg-5 px-3">
                  Privacy Policy
                </div>

                <div className="px-lg-5 px-3">
                  <p>
                    Whatsappbulksend ("we," "our," or "us") very much values the
                    confidentiality and privacy of your personal information.
                    This Privacy Policy, effective from August 2024, covers how
                    the information is collected, used, and disclosed whenever
                    you visit Whatsappbulksend.com, which is now operated by
                    Whatsappbulksend, or when you make any purchase.
                  </p>
                  <p className="text-3-2"> Information We Collect </p>
                  <p>
                    If you please grant us the request, we can, at some
                    intervals, send you emails notifying you about the store,
                    its new stock, or any relevant changes. However, we may need
                    to gather some information, not limited to, your name and
                    email for the purposes of buying or selling. Furthermore,
                    the system automatically collects your IP address whenever
                    you access our site. That allows us to know the system and
                    the browser that is being used.
                  </p>

                  <p className="text-3-2"> Consent </p>
                  <p>
                    <strong>How is consent obtained?</strong>
                  </p>
                  <p>
                    When you give us personal details to perform any tasks such
                    as completing a transaction, validating your credit card,
                    making an order, managing a delivery, or returning an item,
                    you are consenting to collection and use for that particular
                    purpose. Simply put, your cell number serves as your unique
                    identifier, which, as part of license management, is kept in
                    our system. We may use that number to occasionally contact
                    you with helpful information on using our products. If you
                    wish to have your phone number unsaved, you can stop using
                    the app and notify{" "}
                    <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&to= support@Whatsappbulksend.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      support@Whatsappbulksend.com
                    </a>{" "}
                    that you would like to have it removed. We will delete your
                    number from our data within 72 working hours and acknowledge
                    the notice.
                  </p>
                  <p>
                    We will either directly ask for your affirmative consent or
                    give you the option to decline if we ever ask for your
                    information for a purpose other than the one listed, like
                    marketing products to you.
                  </p>

                  <p>
                    <strong> How do I withdraw my consent?</strong>
                  </p>
                  <p>
                    You can email us at{" "}
                    <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&to= support@Whatsappbulksend.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      support@Whatsappbulksend.com
                    </a>{" "}
                    to revoke your consent for contact or for the ongoing
                    collection, use, and/or disclosure of information if you
                    change your mind after opting in.
                  </p>
                  <p className="text-3-2"> Disclosure </p>
                  <p>
                    We may disclose your personal information if required to do
                    so by law, or in the event you breach our Terms of Service.
                  </p>

                  <p className="text-3-2"> Payment </p>
                  <p>
                    Payments shall be processed using the Razorpay Payment
                    Gateway. To be clear, Razorpay does not keep your card
                    information on its servers. In accordance with the Payment
                    Card Industry Data Security Standard (PCIDSS), the data
                    related to your payment transaction is encrypted throughout
                    the process. Purchase transaction data is stored only so
                    long as required to complete the purchase. Thereafter, no
                    further retention of information pertaining to the purchase
                    transaction will be done.
                  </p>
                  <p>
                    The payment gateway follows the PCIDSS as set forth by the
                    PCI Security Standards Council, which is comprised of joint
                    efforts from Visa, MasterCard, American Express, Discover,
                    and others. These standards guarantee secure handling of
                    credit card information by our store and service providers.
                    For further information please visit Razorpay’s terms and
                    conditions https://razorpay.com. .
                  </p>

                  <p className="text-3-2"> Third-party sellers</p>
                  <p>
                    Generally care about collecting, using, and disclosing only
                    that information necessary to offer services to us. However,
                    certain third-party services such as payment gateways, and
                    other payment processors have their own privacy policies
                    regarding the information we provide them for your
                    purchase-related transactions. We advise you to read their
                    privacy policies to see how your personal information will
                    be treated by these providers.
                  </p>
                  <p>
                    Bear in mind that some providers may be located in, or have
                    facilities in, a different jurisdiction from yours, or ours.
                    If you initiate any transaction involving the services of a
                    third-party service provider, your information may be
                    subjected to the applicable laws of the jurisdiction(s)
                    where that service provider or its facilities are located.
                    Once any of your information leaves our website, or is
                    redirected from our website onto the third-party website or
                    application, this Privacy Policy and the Terms of Service
                    for our website cease to be applicable.
                  </p>

                  <p className="text-3-2"> Security </p>
                  <p>
                    Taking reasonable precautions and following the best
                    practices of the industry, we are very well able to confirm
                    that your personal information does not get lost, misused,
                    accessed, disclosed, altered or destroyed in any
                    inappropriate way.
                  </p>

                  <p className="text-3-2"> Cookies </p>
                  <p>
                    Cookies are used to keep your user session going. It does
                    not identify you on any other website.
                  </p>

                  <p className="text-3-2"> Age of Consent</p>
                  <p>
                    You are of legal age in your country or state of residence
                    by using this site, or you are of the age of majority in
                    your state or province of residence and you have given us
                    permission to enable any of your dependent minors to use
                    this site.
                  </p>

                  <p className="text-3-2">
                    {" "}
                    Amendments Made to this Privacy Policy
                  </p>
                  <p>
                    We may change this Privacy Policy at any time, so do well to
                    review it often. Such changes and clarifications will take
                    effect immediately upon their posting on our website. If we
                    make changes to this policy in such a way, we shall leave a
                    notice here, informing you the things, which we collect, how
                    we use it, and under what circumstance if any, we would use
                    and/or disclose it. Your information could then be passed
                    onto the new owners if they buy the store or merge with
                    another company so that we can continue selling products to
                    you.
                  </p>

                  <p className="text-3-2"> Contact Information</p>
                  <p>
                    You may reach out to our Privacy Compliance Officer if you
                    want to access, correct, amend, or delete any personal
                    information we have about you, if you would like to register
                    a complaint, or if you would just like information at{" "}
                    <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&to= support@Whatsappbulksend.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      support@Whatsappbulksend.com
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LandingFooter />
      </div>
    </>
  );
};

export default Privacy;
